import {
  OffersCarousel as SharedOffersCarousel,
  OffersCarouselContentContractForPageTemplate,
  type OffersCarouselProps,
} from '@cx-web/components/page-template/OffersCarousel';
import { captureException } from '@sentry/react-router';

// NGF-6509: the OffersCarousel wrapper now lives in @cx-web/components (single source of truth, shared
// with atlas-astro). This thin RR7 glue carries the one host-specific concern the shared component
// can't:
//   - `onError`: the Sentry capture (@cx-web/components must not depend on @sentry/react-router).
//     Placed AFTER the `{...props}` spread so it always wins.
// NGF-6300: the bare `clickoutServiceUrl` override is no longer read from the ambient global ENV here.
// The OFFERS_CAROUSEL componentMap entry passes it through props (sourced from
// ComponentLoaderContext.clickoutUrl); atlas-astro applies the equivalent override in its island
// load(). Astro-island safe.
export const OffersCarousel = (props: OffersCarouselProps) => (
  <SharedOffersCarousel {...props} onError={captureException} />
);

export { OffersCarouselContentContractForPageTemplate };
export type { OffersCarouselProps };
